import React from 'react'
import { Typography, withStyles, Modal, IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/DeleteOutline'
import styles from './styles'
import { ModalContent, BadgeGrid } from './components'
import { useBadgeSettings } from './logic/use-badge-settings'
import UserType from 'src/model/user-types'
import { CoreTextField } from 'src/components/core'
const BadgeImage = props => {
  const { classes, badges, badgeSettings, settings } = props
  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]

  const {
    ribbonText,
    content,
    selectedBadge,
    modalOpen,
    setModalOpen,
    handleSelectedBadge,
    handleRibbonText,
    handleContent,
    handlePopupOpen,
    handleContentText,
    handleRibbon,
    handleDrawerClose,
    activeTab,
    handleTabChange,
    customBadgeImage,
    customBadgeId,
    handleOpenGallery,
    handleDeleteCustomBadge,
  } = useBadgeSettings(badgeSettings, settings)

  return (
    <div className={classes.container}>
      {/* Tabs */}
      <div className={classes.tabsContainer}>
        <button
          className={`${classes.tab} ${activeTab === 0 ? classes.tabActive : ''}`}
          onClick={() => handleTabChange(0)}
        >
          <svg
            className={classes.tabIcon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          Upload your own badge
        </button>
        <button
          className={`${classes.tab} ${activeTab === 1 ? classes.tabActive : ''}`}
          onClick={() => handleTabChange(1)}
        >
          <svg
            className={classes.tabIcon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
          </svg>
          Select from templates
        </button>
      </div>

      {/* Upload Your Own Badge Tab */}
      {activeTab === 0 && (
        <>
          <div className={classes.inputRow}>
            <TextFieldWithCharCount
              label="Badge title"
              value={content}
              handleChange={handleContentText}
              handleBlur={handleContent}
              maxLength={32}
              classes={classes}
              fullWidth
            />
          </div>
          <div className={classes.uploadSection}>
            <Typography className={classes.uploadSectionTitle}>
              Upload your own design
            </Typography>
            <div className={classes.uploadContainer}>
              {customBadgeImage ? (
                <div className={classes.uploadDropzoneWithImage}>
                  <img
                    src={customBadgeImage}
                    alt="Custom badge"
                    className={classes.uploadedImage}
                    onClick={handleOpenGallery}
                  />
                  <IconButton
                    className={classes.customBadgeDeleteBtn}
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation()
                      if (customBadgeId) handleDeleteCustomBadge(customBadgeId)
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </div>
              ) : (
                <div className={classes.uploadDropzone} onClick={handleOpenGallery}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#919EAB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </div>
              )}
              <div className={classes.uploadInfo}>
                <Typography className={classes.uploadInfoText}>
                  Supported formats: JPG, GIF, or PNG. Maximum file size: 800K
                </Typography>
                <Typography className={classes.uploadInfoText}>
                  Recommended aspect ratio: 1:1
                </Typography>
              </div>
            </div>
          </div>

        </>
      )}

      {/* Select from Templates Tab */}
      {activeTab === 1 && (
        <>
          <div className={classes.inputRow}>
            <TextFieldWithCharCount
              label="Badge title"
              value={content}
              handleChange={handleContentText}
              handleBlur={handleContent}
              maxLength={32}
              classes={classes}
            />
            <TextFieldWithCharCount
              label="Ribbon label"
              value={ribbonText}
              handleChange={handleRibbon}
              handleBlur={handleRibbonText}
              maxLength={12}
              classes={classes}
            />
          </div>
          <Typography className={classes.badgeStyleHeading}>
            Choose a badge image
          </Typography>
          <BadgeGrid
            badges={badges}
            userControl={userControl}
            selectedBadge={selectedBadge}
            handleSelectedBadge={handleSelectedBadge}
            handlePopupOpen={handlePopupOpen}
            ribbonText={ribbonText}
            content={content}
            classes={classes}
          />
          {userControl === 'Basic' ? (
            <UpgradeMessage classes={classes} />
          ) : (
            <NoLogoMessage
              classes={classes}
              handleDrawerClose={handleDrawerClose}
            />
          )}
        </>
      )}

      <Modal
        open={modalOpen}
        onClose={handlePopupOpen}
        className={classes.modal}
      >
        <ModalContent setModalOpen={setModalOpen} />
      </Modal>
    </div>
  )
}

const TextFieldWithCharCount = ({
  label,
  value,
  handleChange,
  handleBlur,
  maxLength,
  classes,
  fullWidth,
}) => (
  <div className={fullWidth ? classes.inputFieldFull : classes.inputField}>
    <CoreTextField
      label={label}
      value={value}
      onChange={e => handleChange(e.target.value)}
      onBlur={e => handleBlur(e.target.value)}
    />
    <div className={classes.charCount}>
      <Typography className={classes.charCountText}>
        {value.length}/{maxLength}
      </Typography>
    </div>
  </div>
)

const UpgradeMessage = ({ classes }) => (
  <Typography className={classes.tipMessage}>
    To select badge styles and add your logo, you can upgrade to paid plans.
    <span
      onClick={() => {
        window.open('/pricing', '_self')
      }}
      className={classes.settingDrawerOpenSpan}
    >
      {' '}
      Click to upgrade.
    </span>
  </Typography>
)

const NoLogoMessage = ({ classes, handleDrawerClose }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
    }}
  >
    <Typography className={classes.tipMessage}>
      If you do not have a logo, it will be left blank. You can add a logo from
      landing page's settings.
    </Typography>
  </div>
)

export default withStyles(styles)(BadgeImage)
